export { getSweetpassUpgradeContentfulTag } from './getSweetpassUpgradeContentfulTag';
